<template>
  <div style="position: relative">
    <div style="position: absolute;left: 20px;top: 10px;z-index: 999999">
      <Language/>
    </div>
    <div class="container-fluid p-0">
      <div class="row m-0">
        <div class="col-xl-7 b-center bg-size p-0"
             :style="{ backgroundImage: 'url('+ require('../assets/images/login/2.jpg') +')' }"
             style="background-size: cover; background-position: center center; display: block;">
        </div>
        <div class="col-xl-5 p-0">
          <div class="login-card">
            <div>
              <div>
                <a class="logo" target="_blank" href="https://www.gameofbusiness.eu/">
                  <img
                      class="img-fluid for-light"
                      src="../assets/images/logo/logo.png"
                      alt="looginpage"
                  />
                </a>
              </div>
              <div class="login-main login-form-card">
                <form novalidate @submit.prevent class="theme-form">
                  <h4>{{ $t('message.login_title') }}</h4>
                  <p>{{ $t('message.login_subtitle') }}</p>
                  <div class="form-group">
                    <label class="col-form-label">{{ $t('message.register_email_label') }}</label>
                    <input
                        v-model="email"
                        v-validate.disable="'required|email'"
                        class="form-control"
                        type="email"
                        name="email"
                    />
                    <span class="error-red mt-4" v-if="errors.first('email')">{{
                        $t("message.register_error_email")
                      }}</span>
                  </div>
                  <div class="form-group">
                    <label class="col-form-label">{{ $t('message.register_password') }}</label>
                    <input
                        v-model="password"
                        v-validate.disable="{
                                    required: true,
                                    min: 8,
                                    regex: /^(?=.*?[A-Z])(?=.*?[a-z]).*$/
                                }"
                        class="form-control"
                        type="password"
                        name="password"
                    />
                    <span class="error-red mt-4" v-if="errors.first('password')">{{
                        $t("message.register_error_password")
                      }} </span>
                  </div>

                  <div class="form-group mb-0">
                    <button @click="onSubmit" class="btn btn-primary btn-block" type="submit">
                      {{ $t('message.register_login') }}
                    </button>
                  </div>
                  <p class="mt-4 mb-0">
                    {{ $t('message.login_dont_have_account') }}
                    <router-link
                        class="ml-2"
                        tag="a"
                        to="/auth/register"
                    >
                      {{ $t('message.register_create_account') }}
                    </router-link>
                  </p>
                  <p class="mt-2 mb-0">
                    {{ $t('message.login_dont_forgot') }}
                    <router-link
                        class="ml-2"
                        tag="a"
                        to="/auth/forgot-password"
                    >
                      {{ $t('message.login_new_password') }}
                    </router-link>
                  </p>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Language from './../components/header/language';

export default {
  components: {
    Language
  },
  data: function () {
    return {
      email: "",
      password: "",
      showPassword: false
    };
  },
  created() {
    // this.checkLogin()
  },
  methods: {

    checkLogin() {

      // this.$store.dispatch('shared/setLoading', true)
      // this.$store.dispatch('shared/tryAutoLogin').then((isLoged) => {
      //     if (!isLoged) {
      //         this.$store.dispatch('shared/setLoading', false)
      //     } else {
      //         this.$router.push({name: 'ProjectsList'})
      //
      //     }
      // })
    },

    onSubmit() {

      this.$validator.validate().then(valid => {

        if (valid) {
          this.$store.dispatch("shared/login", {
            email: this.email,
            password: this.password,
            from: "admin"
          }).then((res) => {

            if (res.name != '') {
              this.$router.push({name: 'ProjectsList'})
            } else {
              this.$router.push({name: 'UserProfile'})
            }

          });
        }
      })
    }
  }
};
</script>
